import React from "react";

/*
The tooltip needs to apply DOM event listeners to its child element.
If the child is a custom React element,you need to make sure that
it spreads its properties to the underlying DOM element.
https://material-ui.com/components/tooltips/#tooltip
*/

interface TooltipProps {
  children: React.ReactNode;
  [key: string]: any;
}

const CustomTooltip = React.forwardRef<HTMLDivElement, TooltipProps>(
  ({ children, ...props }, ref) => (
    <div ref={ref} {...props}>
      {children}
    </div>
  ),
);

export default CustomTooltip;
